import React, { FunctionComponent } from 'react';
import TaxInformation from 'libraries/wizard/components/tax-information';
import useTaxInformation from './use-tax-information';

const TaxInformationStep: FunctionComponent<{}> = () => {
  const props = useTaxInformation();

  return <TaxInformation {...props} />;
};

export default TaxInformationStep;
